import { LOADING_LOCATIONS } from '../constants/action-types';
export const loadingLocations = () => ({
    type: LOADING_LOCATIONS,
});
